module.exports = __webpack_public_path__ + "2c9b35ee02aa2991b78b0d02a93eb1cf.jpg";